/**
 * Canonical unit-type palette for learning-time analytics (donut slices,
 * legends, tooltips). Must match across every breakdown surface — do not
 * restyle per widget.
 */
const UnitTypeColors: Record<keyof LearningTime, string> = {
	video: '#6C63FF',
	document: '#FF8532',
	test: '#FFD037',
	webinar: '#A0A2FF',
	webcontent: '#36A2EB',
	assignment: '#00CE67',
}

export default UnitTypeColors
